import React from "react";
import "../css/ContentPage.css";
import service_three from "../images/flexi_loan.jpg";
import { Link } from "react-router-dom";
import ChatButton from "../components/ChatButton";


const ShortLoan = () => {
  return (
    <>
      <div className="content_page_wrapper">
        <div className="content_page_banner_wrapper">
          <div className="service_page_banner_wrapper_overlay">
            <h2>Mini Loan</h2>
          </div>

          <div className="text_content_wrapper">
            <div className="text_content">
              {/* <div className="content_banner">
                <img src={service_three} alt="" />
              </div> */}
              <div>
                <h2 className="page_title mt30 mb20">Mini Loan</h2>

                <p>Many times, small but unexpected expenses arise, requiring immediate funds to cover the cost. What to do then? Borrow from family/friends, break FD, or consume savings? These are outdated ways. CreduMoney, the best online lending app, has the smartest way to navigate such low-value financial challenges. Such minor expenses can be swiftly covered using our Mini Loans, ranging from 5000 to 1 LAKH.</p>
                <p>The best part of this loan is that the entire process, right from the application to verification to disbursal, is completely digital. Inculcating the use of advanced technology has only driven amazing results, allowing us to disburse the loan amount within 5 to 10 minutes. Another advantage is that our mini loans don’t require a bundle of documents; just PAN, Aadhar, and a Bank Statement are enough to get instant approval. Also, we do not ask our borrowers to pledge collateral or impose any hidden charges.</p>
                <p>Therefore, whether you need immediate cash for low-value online purchases, minor vehicle repairs or services, day-to-day expenses, rent, small debt, school/college/tuition fees, utility bills, medicine cost, or you simply need cash for a minor get-together, getaway, or trip, we ensure you never miss out on anything. With CreduMoney, borrowing is easy, fast, and secure, so it doesn’t feel like a burden to you. </p>

              </div>
              <div className="button_container flex justify-center">
                <Link to="/apply-now">Apply Now</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ChatButton />
    </>
  );
};

export default ShortLoan;
